{
  "slug": "lakobloom",
  "status": "preview",
  "isDemoContent": true,
  "name": "Детейлинг-студия «Лакоблум»",
  "tagline": "Полировка, защитные покрытия и химчистка салона",
  "about": "Студия детейлинга с боксом на два поста и отдельной сушильной камерой. Работаем по записи: каждая машина закрепляется за одним мастером от приёмки до выдачи.",
  "address": "Кутузовский проспект, 88, бокс 4",
  "addressNote": "Заезд с торца здания, шлагбаум открывается по звонку.",
  "phone": "+78123456789",
  "phoneDisplay": "+7 (812) 345-67-89",
  "accent": {
    "light": "#C2410C",
    "dark": "#FFB08A"
  },
  "timezone": "Europe/Samara",
  "workingHours": [
    {
      "weekday": 0,
      "opensAt": "11:00",
      "closesAt": "18:00"
    },
    {
      "weekday": 2,
      "opensAt": "08:00",
      "closesAt": "22:00"
    },
    {
      "weekday": 3,
      "opensAt": "08:00",
      "closesAt": "22:00"
    },
    {
      "weekday": 4,
      "opensAt": "08:00",
      "closesAt": "22:00"
    },
    {
      "weekday": 5,
      "opensAt": "08:00",
      "closesAt": "22:00"
    },
    {
      "weekday": 6,
      "opensAt": "08:00",
      "closesAt": "22:00"
    }
  ],
  "resources": [
    {
      "name": "Бокс А",
      "kind": "bay",
      "sortOrder": 10
    },
    {
      "name": "Бокс Б",
      "kind": "bay",
      "sortOrder": 20
    },
    {
      "name": "Сушильная камера",
      "kind": "equipment",
      "sortOrder": 30
    }
  ],
  "infoCards": [
    {
      "title": "Один мастер на машину",
      "body": "От приёмки до выдачи автомобилем занимается один человек — спросить можно напрямую у него."
    },
    {
      "title": "Работы на сутки и дольше",
      "body": "Полировка и керамика занимают от одного до двух дней. Бокс на это время закреплён за вами."
    },
    {
      "title": "Показываем до и после",
      "body": "Снимаем кузов под лампой до работ и после, отчёт отдаём вместе с машиной."
    }
  ],
  "services": [
    {
      "slug": "abrazivnaya-polirovka",
      "name": "Абразивная полировка кузова",
      "summary": "Снятие рисок и голограмм в два прохода с замером толщины ЛКП.",
      "priceFromRub": 18000,
      "durationMinMinutes": 480,
      "durationMaxMinutes": 960,
      "bufferMinutes": 60,
      "sortOrder": 10,
      "includes": [
        "Мойка и обезжиривание кузова",
        "Замер толщины лакокрасочного покрытия",
        "Полировка в два прохода",
        "Финишная располировка"
      ],
      "notes": [
        "Машина остаётся в студии минимум на сутки, при большом объёме — на двое.",
        "На переварке и шпатлёвке полировка не выполняется."
      ],
      "resources": [
        "Бокс А",
        "Бокс Б"
      ]
    },
    {
      "slug": "keramika",
      "name": "Керамическое покрытие",
      "summary": "Нанесение керамики в три слоя с сушкой в камере.",
      "priceFromRub": 35000,
      "durationMinMinutes": 960,
      "durationMaxMinutes": 1440,
      "bufferMinutes": 120,
      "sortOrder": 20,
      "includes": [
        "Подготовка и обезжиривание",
        "Нанесение трёх слоёв состава",
        "Сушка в камере",
        "Контроль покрытия под лампой"
      ],
      "notes": [
        "Требуется предварительная полировка — считается отдельно.",
        "Первые сутки после нанесения машину нельзя мочить."
      ],
      "resources": [
        "Сушильная камера"
      ]
    },
    {
      "slug": "himchistka-salona",
      "name": "Химчистка салона",
      "summary": "Полная химчистка с извлечением сидений и обработкой потолка.",
      "priceFromRub": 9000,
      "durationMinMinutes": 300,
      "durationMaxMinutes": 480,
      "bufferMinutes": 60,
      "sortOrder": 30,
      "includes": [
        "Демонтаж сидений",
        "Химчистка ткани и пластика",
        "Обработка потолка",
        "Озонирование"
      ],
      "notes": [
        "Сильные застарелые пятна могут не уйти полностью — предупредим на приёмке."
      ],
      "resources": [
        "Бокс А",
        "Бокс Б"
      ]
    }
  ]
}
